import { render, staticRenderFns } from "./SidemenuIcon.vue?vue&type=template&id=7997e36e&scoped=true"
import script from "./SidemenuIcon.vue?vue&type=script&lang=js"
export * from "./SidemenuIcon.vue?vue&type=script&lang=js"
import style0 from "./SidemenuIcon.vue?vue&type=style&index=0&id=7997e36e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7997e36e",
  null
  
)

export default component.exports